import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-phone-number-input/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.headers.Accept = 'application/json';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
      <App/>
  </BrowserRouter>
);

reportWebVitals();
